import { Box, IconButton, Stack } from '@mui/material'
import React, { useEffect, useMemo, useRef, useState } from 'react'

import DoDisturbOnOutlinedIcon from '@mui/icons-material/DoDisturbOnOutlined'
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined'
import { makeGetRequest } from 'utils/api'
import urls from 'utils/urls'
import { DataGrid } from '@mui/x-data-grid'
import { makePostRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import CreateOpportunityForm from './CreateOpportunityForm'

export default function OpportunityCard() {
  const { t, i18n } = useTranslation('layout') // LAP-733 (GE022)
  const [operations, setOperations] = useState({ results: [] })

  const [fistinit, setFirstInit] = useState(false)
  const [selectedRows, setSelectedRows] = useState([])
  const sstop1 = useRef(0)
  const scroollLoading1 = useRef(false)

  useEffect(() => {
    fetchOperations2()
  }, [])
  useEffect(() => {
    const gridElement = document.querySelector('#opp-suivi .MuiDataGrid-virtualScroller')

    if (gridElement) {
      gridElement.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (gridElement) {
        gridElement.removeEventListener('scroll', handleScroll)
      }
    }
  }, [operations])

  const handleScroll = async () => {
    const gridElement = document.querySelector('#opp-suivi .MuiDataGrid-virtualScroller')

    if (!gridElement) return

    const { scrollTop, scrollHeight, clientHeight, scrollLeft } = gridElement
    if (sstop1.current !== scrollLeft) {
      sstop1.current = scrollLeft
      return
    }

    if (scrollTop + clientHeight >= scrollHeight) {
      if (!scroollLoading1.current) {
        scroollLoading1.current = true
        const url = `limit=20&offset=${operations.results.length}`
        await fetchOperations2(url)
        scroollLoading1.current = false
      }
    }
  }
  const fetchOperations2 = async (pagination = '') => {
    let url = `/api/investment/tracked-opportunitie-operations/`
    if (pagination !== '') {
      //general=true&
      url += '?' + pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({
        ...response.data,
        results: [...operations.results, ...response.data.results],
      })
    }
  }
  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      // LAP-733 (GE022)
      alert(t('investments.portfolio.selectOpAlert'))
    } else {
      const response = await makePostRequest(
        '/api/investment/tracked-opportunitie-delete/',
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        const filteredOperations = operations.results.filter(
          (v) => selectedRows.indexOf(v.id) === -1,
        )
        setOperations({
          ...operations,
          results: filteredOperations,
          count: operations.count - selectedRows.length,
        })
      }
    }
  }
  // LAP-733 (GE022)
  const columns = useMemo(
    () => [
      {
        field: 'type_id',
        headerName: t('investments.portfolio.cols.type'),
        width: 50,
        editable: false,
        renderCell: (params) => params.row.type_id,
      },
      {
        field: 'name',
        headerName: t('investments.portfolio.cols.title'),
        width: 130,
        editable: false,
        renderCell: (params) => params.row.name,
      },
      {
        field: 'price',
        headerName: t('investments.portfolio.cols.price'),
        width: 70,
        editable: false,
        renderCell: (params) => params.row.price,
      },
      {
        field: 'target_price',
        headerName: t('investments.portfolio.cols.targetPrice'),
        width: 90,
        editable: false,
        renderCell: (params) => params.row.target_price,
      },
      {
        field: 'target_value',
        headerName: t('investments.portfolio.cols.targetValue'),
        width: 90,
        editable: false,
        renderCell: (params) => params.row.target_value,
      },
      {
        field: 'value_change',
        headerName: t('investments.portfolio.cols.valueChange'),
        width: 70,
        editable: false,
        renderCell: (params) => (
          <Box sx={{ color: params.row.value_change > 0 ? 'green' : 'red' }}>
            {params.row.value_change}
          </Box>
        ),
      },
      {
        field: 'value_change_pct',
        headerName: t('investments.portfolio.cols.valueChangePct'),
        width: 90,
        editable: false,
        renderCell: (params) => (
          <Box sx={{ color: params.row.value_change_pct > 0 ? 'green' : 'red' }}>
            {params.row.value_change_pct}
          </Box>
        ),
      },
    ],
    [t, i18n.language],
  )
  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'}>
      <Box>
        <Box display={'flex'} sx={{ fontSize: 20, fontWeight: 500 }}>
          {/* LAP-733 (GE022) */}
          <Box>{t('investments.portfolio.opportunity.title')}</Box>
          <Box sx={{ marginLeft: 'auto' }}>
            <Stack
              style={{
                flexDirection: 'row',
                justifyContent: 'flex-end',
              }}
              sx={{ '.MuiButtonBase-root': { padding: 0 }, gap: 1, mt: 0.5 }}
            >
              <IconButton sx={{ color: 'white' }} onClick={() => ''}>
                <CreateOpportunityForm setOperations={setOperations} />
              </IconButton>
              <IconButton sx={{ color: 'white' }} onClick={deleteBulkOperations}>
                <DoDisturbOnOutlinedIcon />
              </IconButton>
            </Stack>
          </Box>
        </Box>
      </Box>
      <Box mt={1} height={'100%'} id="opp-suivi">
        <DataGrid
          sx={{
            '.MuiTablePagination-toolbar': {
              alignItems: 'baseline',
            },
            '.MuiDataGrid-footerContainer': {
              background: 'white',
            },
            color: 'white',
            '.MuiCheckbox-root': {
              color: 'white',
            },
            '.Mui-checked': {
              color: 'white !important',
            },
            '.MuiSvgIcon-root': {
              fill: 'white',
            },
            border: 'unset',
          }}
          rows={operations.results ? operations.results : []}
          columns={columns}
          pageSize={20}
          rowCount={operations.count ? operations.count : 0}
          rowsPerPageOptions={[10, 20, 40, 80, 100]}
          pagination
          onSelectionModelChange={(itm) => setSelectedRows([...itm])}
          paginationMode="server"
          hideFooter
          components={{
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                {/* LAP-733 (GE022) */}
                {t('investments.portfolio.noRows')}
              </Stack>
            ),
            NoResultsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                {/* LAP-733 (GE022) */}
                {t('investments.portfolio.noRows')}
              </Stack>
            ),
          }}
          checkboxSelection
        />
      </Box>
    </Box>
  )
}
